import { Button, Flex, IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';
import { useEffect, useState } from 'react';

import { QueryTable } from '@app/components/common/table';
import { useAlert, useApi, useGuide } from '@app/hooks';
import { SelectField, TextField } from '@app/components/common';

import Dialog from '../../common/modals/dialog';

export const CheckStatusEditModal = ({
  variant = 'icon',
  id,
  currentStatus,
  currentComment,
  onDone,
  onClose,
}: {
  variant?: 'icon' | 'button';
  id: string | number;
  currentStatus: EntityBase;
  currentComment: string;
  onDone?(): void;
  onClose?(): void;
}) => {
  const api = useApi();
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [statusOptions, setStatusOptions] = useState<EntityBase[]>([]);
  const getStatusOptions = useGuide('checked_statuses');
  const { refetch } = QueryTable.useQueryTable();
  const { info } = useAlert();
  
  const [comment, setComment] = useState('');
  const [status, setStatus] = useState<EntityBase>(statusOptions[0]);

  useEffect(() => {
    setStatus(currentStatus);
    setComment(currentComment);
  }, [currentStatus, currentComment]);

  useEffect(() => {
    getStatusOptions().then((data) => {
      setStatusOptions(data);
    });
  }, []);

  const onSubmit = async () => {
    try {
      setLoading(true);
      const response = await api.equipments.setCheckedState(id, Number(status.id), comment);
      if (response.code === 200) {
        info(response.message);
        refetch();
        onDone?.();
      }

    } catch (e) {
      console.error(e);
      onClose?.();
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  return (
    <>
      {variant === 'icon' && <IconButton onClick={() => setOpen(true)} isLoading={loading} aria-label="status-edit">
        <MdEdit />
      </IconButton>}
      <Dialog
        open={isOpen}
        onClose={() => setOpen(false)}
        title="Закрыть заявку"
        actions={
          <Flex justifyContent="space-between" flex={1}>
            <Button colorScheme='brand' onClick={onSubmit}>Изменить</Button>
            <Button variant='ghost' onClick={() => setOpen(false)}>Отмена</Button>
          </Flex>
        }
        loading={loading}
      >
        <Flex flexDirection='column' gap={4}>

          <SelectField
            id='status'
            name='status'
            label='Статус проверки'
            value={status}
            options={statusOptions}
            onChange={setStatus}
            clearable={false}
          />
          <TextField 
            multiline
            rows={4}
            id=""
            label="Комментарий"
            value={comment}
            onChange={setComment}
          />

        </Flex>
      </Dialog>
    </>
  );
};
